const PageDefaultModel = {
    type: 'page',
    name: 'default',
    blocks: [
        {
            name: 'breadcrumbs',
            type: 'link',
        },
        {
            name: 'image', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'image', // || text || link || image || mixed (with children)
        },
        {
            name: 'title', // name or id; MUST be unique
            max: 1, // max same items allowed
            type: 'text', // || text || link || image || mixed (with children)
        },
        {
            name: 'schema', // name or id; MUST be unique
            label: 'Schema (JSON-LD)',
            max: 1, // max same items allowed
            type: 'textarea', // raw JSON-LD injected in the <head> script
        },
        {
            name: 'content',
            type: 'mixed',
            blocks: [
                {
                    name: 'text', // name or id; MUST be unique
                    max: 1, // max same items allowed
                    type: 'html', // || text || link || image || mixed (with children)
                },
                {
                    name: 'image',
                    type: 'image',
                    max: 1,
                },
                {
                    name: 'call-to-action',
                    type: 'link',
                    max: 1,
                },
                {
                    // References a CMS panel by slug (e.g. a productList or reviews panel), rendered
                    // via CmsPanel inside the page body.
                    name: 'panel',
                    type: 'panel',
                    max: 1,
                },
                {
                    name: 'position',
                    type: 'select',
                    max: 1,
                    options: ['left', 'right'],
                },
            ],
        },
    ],
};

export default PageDefaultModel;
